<template>
    <span class='tag'>
        <span class="text">{{ text }}</span>
        <fa-icon icon="times-circle" @click="remove" />
        <span class='spacer' />
    </span>
</template>

<script>
export default {
    name: 'tag',
    props: ['text'],

    methods: {
        remove() {
            this.$emit('remove-tag', this.text);
        }
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/style-colors";

    .tag {
        display: inline-flex;
        align-items: center;
        height: 40px;
        border-radius: 20px;
        background-color: $color-grey;
        margin-right: 10px;
        margin-bottom: 10px;

        SVG {cursor: pointer;}

        SPAN.text {padding: 0 10px 0 20px;}
        SPAN.spacer {padding-right: 10px;}

    }
</style>